import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PGWContractRateQueryCriteriaClass extends BaseCriteriaModel {
  payment_channel_hdr_guid?: Optional<string> = Optional.empty();
  contract_hdr_guid?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  obj_type?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

}

export class PGWContractRateCriteriaModelQuery {
  query = '';

  constructor(contractRateCriteriaModel: PGWContractRateQueryCriteriaClass) {
    console.log('pCCriteriaModel', contractRateCriteriaModel);

    if (!contractRateCriteriaModel) {
      return;
    }

    this.query += contractRateCriteriaModel.payment_channel_hdr_guid.filter(x => x !== '').map(x => '&payment_channel_hdr_guid=' + x).orElse('');
    this.query += contractRateCriteriaModel.contract_hdr_guid.filter(x => x !== '').map(x => '&contract_hdr_guid=' + x).orElse('');
    this.query += contractRateCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += contractRateCriteriaModel.obj_type.filter(x => x !== '').map(x => '&obj_type=' + x).orElse('');
    this.query += contractRateCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');


    this.query += '&status=' + contractRateCriteriaModel.status;
    this.query += '&orderBy=' + contractRateCriteriaModel.orderBy;
    this.query += '&order=' + contractRateCriteriaModel.order;
    this.query += '&offset=' + contractRateCriteriaModel.offset + '&limit=' + contractRateCriteriaModel.limit;
  }

}
